import React, { useState } from "react";
import "./Footer.css";
import {
  ContactUsIcon,
  MailIcon,
  SchoolLogo,
  WhatsappIcon,
} from "../../../assets/exports/FileExports";

const Footer = () => {
  const [errorLoading, setErrorLoading] = useState(false);

  const handleError = () => {
    setErrorLoading(true); // Set error state when iframe fails to load
  };

  return (
    <div className="footer-container">
      <div className="main-footer-container">
        <div className="footer-details">
          <div className="footer-titles">
            <img
              className="footer-school-logo"
              src={SchoolLogo}
              alt="school logo"
            />
            <div className="footer-title-container">
              <h3 className="paragraph-title footer-title">Naveen Shiksha</h3>
              <h3 className="footer-secondary-title paragraph-title">
                Bharti Public School
              </h3>
            </div>
          </div>
          <div className="footer-address">
            <p className="footer-line">Harsh Vihar, Delhi-110093</p>
            <h3 className="contact-label">Contact Us:</h3>
            <div className="footer-contact">
              <>
                <img
                  className="footer-icon"
                  src={WhatsappIcon}
                  alt="Whatsapp Us On"
                />
                <p className="footer-line">9810275339,</p>
              </>

              <>
                <img
                  className="footer-icon"
                  src={ContactUsIcon}
                  alt="Call Us On"
                />
                <p className="footer-line">9810275339</p>
              </>
            </div>

            <span className="footer-mail">
              <img className="footer-icon" src={MailIcon} alt="Mail Us" />
              <p className="footer-line">nsbpublicschool2000@gmail.com</p>
            </span>
          </div>
        </div>

        <div className="footer-second-details">
          <div className="footer-titles">
            <div className="footer-title-container">
              <h3 className="map-title">Reach Us at</h3>
            </div>
          </div>
          <p className="map-address-line">
            Naveen Shiksha Bharti Public School, Street No-1, Harsh Vihar, Delhi
            - 110093
          </p>
          <div className="footer-map-container">
            {!errorLoading ? (
              <iframe
                title="NSB Public School on Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3499.6142792990804!2d77.3250937!3d28.701182799999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfb43fe2bf159%3A0x495bfd2f438904ec!2sNaveen%20Shiksha%20Bharti%20Public%20School!5e0!3m2!1sen!2sin!4v1750150909084!5m2!1sen!2sin"
                style={{ border: "0" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                onError={handleError} // Handle error if the iframe URL fails to load
              ></iframe>
            ) : (
              <div>
                <p>Sorry, the map failed to load. Please try again later.</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="footer-copyrights-container">
        <p className="copyrights-declaration">
          &copy; Copyright Naveen Shiksha Bharti Public School All rights
          Reserved
        </p>
      </div>
    </div>
  );
};

export default Footer;
